import { useIntl } from 'react-intl'
import { useFormContext } from 'react-hook-form'

import { InternationalPersonFormPresentational } from '../../../../../../../../components/Forms/InternationalFormPresentational'
import { type InternationalStepFormValues } from './types/FormsSteps'

type InternationalStepFormProps = {
  isSubmitting: boolean
  onCancel: () => void
  onSubmit: () => void
}

export const InternationalStepForm = ({
  isSubmitting,
  onCancel,
  onSubmit,
}: InternationalStepFormProps) => {
  const methods = useFormContext<InternationalStepFormValues>()
  const { formatMessage } = useIntl()

  return (
    <InternationalPersonFormPresentational
      isSubmitting={isSubmitting}
      submitButtonText={formatMessage({ id: 'CONTINUE' })}
      onSubmit={onSubmit}
      onCancel={onCancel}
      {...methods}
    />
  )
}
